import type { SubmitCommentResponse, FlagContentResponse, MarkCommentHelpfulResponse } from '@mrb91002/shared-types'

import { secureFetch, SECURE_API_BASE } from './helpers'

/**
 * Submit a comment on a pattern, material, or project
 */
export async function submitComment(
  entityType: 'pattern' | 'material' | 'project',
  entityId: string,
  text: string,
  images: string[],
  parentCommentId: string | undefined,
  idToken: string,
): Promise<SubmitCommentResponse> {
  const entityPath = entityType === 'material' ? 'material' : entityType === 'project' ? 'craft-project' : 'pattern'
  const url = `${SECURE_API_BASE}/${entityPath}/${entityId}/comment`
  const payload = {
    text,
    images: images.length > 0 ? images : undefined,
    parent_comment_id: parentCommentId,
  }
  return secureFetch<SubmitCommentResponse>(url, idToken, {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}

/**
 * Toggle comment helpful status
 */
export async function toggleCommentHelpful(
  commentId: string,
  entityType: string,
  entityId: string,
  idToken: string,
): Promise<MarkCommentHelpfulResponse> {
  const url = `${SECURE_API_BASE}/comment/${commentId}/helpful?entity=${entityType}&entityId=${entityId}`
  return secureFetch<MarkCommentHelpfulResponse>(url, idToken, { method: 'POST' })
}

/**
 * Flag content for moderation
 */
export async function flagContent(
  contentType: string,
  contentId: string,
  reason: 'inappropriate' | 'spam' | 'copyright' | 'misleading' | 'other',
  idToken: string,
  customReason?: string,
  details?: string,
): Promise<FlagContentResponse> {
  return secureFetch<FlagContentResponse>(`${SECURE_API_BASE}/flag/${contentType}/${contentId}`, idToken, {
    method: 'POST',
    body: JSON.stringify({ reason, custom_reason: customReason, details }),
  })
}

// uploadCommentImage is available via secure/images.ts unified upload
